module.exports = __webpack_public_path__ + "audio/eightAudio.a7a8bb42.mp3";